import { useMutation } from '@apollo/client'
import { Box, FormModal, Link, Text } from '@chaine/keychaine'
import React, { useState } from 'react'
import { SubmitHandler } from 'react-hook-form'

import { Toast } from '../../../_shared/components/toast'
import { validations } from '../../../_utils/validations/validations'
import { AppModalProps } from '../components/apps-data'
import { ENABLE_MY_CARRIER_PORTAL_APP } from '../data/mutations'

/**
 * Enables the MyCarrierPortal app for Chaine.
 * @param props.app the app
 * @param props.isOpen sets the modal to open or closed
 * @param props.onClose closes the modal
 */
const MyCarrierPortalAppModal = React.memo((props: AppModalProps) => {
  const { isOpen, onClose, appType, app } = props
  const [formError, setFormError] = useState('')

  const { showToast } = Toast()

  const [enableMyCarrierPortalApp, { loading: enableAppLoading }] = useMutation(ENABLE_MY_CARRIER_PORTAL_APP, {
    onCompleted: () => {
      showToast({ status: 'success', title: 'MyCarrierPortal App Enabled' })
      onClose()
    },
    onError: (error) => {
      showToast({ status: 'error', title: error.message })
    }
  })

  const footer = (
    <Box>
      <Text color="red.600">{formError}</Text>
      <Text>
        {`See `}
        <Link color="blue.600" href={app.docs} target="_blank" rel="noopener noreferrer">
          detailed steps here.
        </Link>
      </Text>
    </Box>
  )

  type FieldValues = { apiPassword?: string; onboardingURL?: string; username?: string }
  const handleSaveDetails: SubmitHandler<FieldValues> = (event) => {
    const { onboardingURL, apiPassword, username } = event
    enableMyCarrierPortalApp({
      variables: { appType: appType, onboardingURL, password: apiPassword, username }
    })
  }

  const closeModal = () => {
    setFormError('')
    onClose()
  }
  return (
    <>
      <FormModal
        isOpen={isOpen}
        onClose={closeModal}
        title={`Enable ${appType} for Chaine`}
        subtitle={`MyCarrierPortal integration requires an API username and password. Please create one under Integration tools.`}
        formSubmitHandler={handleSaveDetails}
        buttonText={'Enable'}
        initialValues={{}}
        validations={validations}
        isLoading={enableAppLoading}
        footer={footer}
        modalItems={[
          {
            labelText: "MyCarrierPortal API User's username",
            name: 'username',
            placeHolder: 'Enter your MyCarrierPortal API User username',
            type: 'input'
          },
          {
            labelText: "MyCarrierPortal API User's password",
            name: 'apiPassword',
            placeHolder: 'Enter your MyCarrierPortal API User password',
            type: 'input'
          },
          {
            labelText: 'MyCarrierPortal Intellivite Link',

            name: 'onboardingURL',
            placeHolder: 'Intellivite Link can be found under "Integration Tools"',
            type: 'input'
          }
        ]}
      />
    </>
  )
})

MyCarrierPortalAppModal.displayName = 'MyCarrierPortalApp'

export { MyCarrierPortalAppModal }
